module.exports = __webpack_public_path__ + "static/media/DysmateHåndbok_v1.1_compressed.becc62ec.pdf";